import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/services/guards/auth-guard.service';
import { DynamicDashboardResolverService } from '@shared/modules/dynamic-dashboards/dynamic-dashboard-resolver.service';
import { VeselContainerComponent } from '@dashboard/container/vesel-container/vesel-container.component';
import { DashboardContainerComponent } from '@dashboard/container/dashboard-container/dashboard-container.component';
import { VesselWrapperResolverService } from '@dashboard/vessel-wrapper-resolver';
import { VesselInfoResolverService } from '@dashboard/vessel-info-resolver';
import { VesselInfoComponent } from '@dashboard/components/vessel-info/vessel-info.component';

export const RouteIds = {
  vesselImo: 'vesselImo',
  tab: 'tab',
};
export const RouteStatics = {
  tools: 'tools',
  infoPage: 'info',
  infoPageWithTab: `info/:${RouteIds.tab}`,
  particulars: 'particulars',
  graphs: 'graphs',
  summary: 'summary',
  voyages: 'voyages',
};

const routes: Routes = [
  {
    path: '',
    resolve: {
      dashboard: DynamicDashboardResolverService,
    },
    runGuardsAndResolvers: 'pathParamsChange',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        // component: DynamicDashboardWrapperComponent,
        component: DashboardContainerComponent,
        children: [
          {
            path: `:${RouteIds.vesselImo}`,
            component: VeselContainerComponent,
            resolve: {
              vesselWrapper: VesselWrapperResolverService,
            },
            runGuardsAndResolvers: 'pathParamsChange',
            children: [
              {
                path: 'info',
                redirectTo: `info/${RouteStatics.particulars}`,
                pathMatch: 'full',
              },
              {
                path: RouteStatics.infoPageWithTab,
                component: VesselInfoComponent,
                resolve: {
                  vesselInfo: VesselInfoResolverService,
                },
                runGuardsAndResolvers: 'pathParamsChange',
              },
            ],
          },
          {
            path: RouteStatics.tools,
            loadChildren: () =>
              import('../../../modules/tools-page/tools-page.module').then(
                (m) => m.ToolsPageModule
              ),
          },
        ],
        data: {
          title: 'Dashboard',
        },
      },
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DynamicDashboardRoutingModule {}
